module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"calendar":{"go":{"today":"Go to today","prevMonth":"Previous Month","nextMonth":"Next Month"}}}}')
  delete Component.options._Ctor
}
